import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setSpecializationFormAction } from "../../redux/rootReducer";
import { SPECIALIZATION_FORM_INITIAL } from "../../redux/initialStateConstant";
import { UpdateSpecializationThunk } from "../../redux/thunks/UpdateSpecializationThunk";

const SpecializationForm = () => {
    const dispatch = useDispatch();
    const specialization_form = useSelector(state => state.specialization_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setSpecializationFormAction(SPECIALIZATION_FORM_INITIAL));
                            } }
                        />
                        <div className="form__title">Специализация</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название специализации</div>
                        <input type="text" className="input"
                            value={ specialization_form.name }
                            onInput={ event => {
                                dispatch(setSpecializationFormAction({
                                    ...specialization_form,
                                    name: event.target.value
                                }));
                            } }
                        />
                    </div>

                    <div className="form__field">
                        <div className="button button--green"
                            onClick={ () => {
                                dispatch(UpdateSpecializationThunk({
                                    specialization_id: specialization_form.id,
                                    name: specialization_form.name
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpecializationForm;